"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatorIntentResponse = void 0;
var CreatorIntentResponse;
(function (CreatorIntentResponse) {
    let intentTarget;
    (function (intentTarget) {
        intentTarget["SESP_SUBMISSION"] = "sesp.submission";
        intentTarget["MAD_MEN_DEPLOYMENT"] = "mad-men.deployment";
        intentTarget["GENERAL"] = "general";
        intentTarget["MAD_MEN_GROUP"] = "mad-men.group";
    })(intentTarget = CreatorIntentResponse.intentTarget || (CreatorIntentResponse.intentTarget = {}));
    let intentType;
    (function (intentType) {
        intentType["INTERESTED"] = "interested";
    })(intentType = CreatorIntentResponse.intentType || (CreatorIntentResponse.intentType = {}));
})(CreatorIntentResponse = exports.CreatorIntentResponse || (exports.CreatorIntentResponse = {}));
